import { Row } from "@tanstack/react-table";

export function compareAlphabetically<T>(
  rowA: Row<T>,
  rowB: Row<T>,
  columnId: string,
): number {
  return String(rowA.getValue(columnId)).localeCompare(
    String(rowB.getValue(columnId)),
    undefined,
    { sensitivity: "base" },
  );
}
